export const ESTABLISHMENTS_LIST_KEY = 'ESTABLISHMENTS_LIST';
export const ESTABLISHMENTS_ONE_KEY = 'ESTABLISHMENTS_ONE_KEY';
